import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Appointment } from "../engine/models/models";

@Injectable({ providedIn: "root" })

export class CustomFeaturesAddendumService {
  constructor(private http: HttpClient) { }

  downloadCFAByEmailAndContractId(contractId: number, email: string): Observable<any> {
    return this.http.get<any>(`${environment.api}/api/PDF/${contractId}/${email}`);
  }

  downloadCFA(appointment: Appointment): Observable<any> {

    const getCircularReplacer = () => {
      const seen = new WeakSet();
      return (key, value) => {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return; // Skip serialization of circular reference
          }
          seen.add(value);
        }
        return value; // Return value to be serialized
      };
    };

    // Manually serialize and deserialize the appointment object to JSON
    const cleanedAppointment: Appointment = JSON.parse(JSON.stringify(appointment, getCircularReplacer()));

    for (const option of cleanedAppointment.options) {
      if (option.areaId > 1) {
        if (option.childOptions) {
          // Iterate over all child options
          for (const childOption of option.childOptions) {
            if (childOption.isSelected || childOption.isAdded) {
              if (!option.isVisible || !childOption.isVisible) {
                childOption.isSelected = false;
                childOption.isAdded = false;
              }
            }
          }
        } else {
          if ((option.isSelected || option.isAdded) && !option.isVisible) {
            option.isSelected = false;
            option.isAdded = false;
          }
        }
      }
    }

    let postUrl = `${environment.api}/api/PDF/exportSelections`;
    const observable = this.http.post<Appointment>(postUrl, cleanedAppointment);
    observable.subscribe(
      data => console.log('Observable Data:', data),
      error => console.error('Observable Error:', error)
    );
    return observable;
  }

  downloadfavorited(model: any): Observable<any> {
    return this.http.post<any>(`${environment.api}/api/pdf/exportLikedFeature`, model);
  }
}
